module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }